import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  state = {
    ruleState: false
  }
  render() {
    let { language, lang, rewardList } = this.props
    return (
      <div style={{ display: this.props.selectState === '2' ? 'block' : 'none' }}>
        {/* reward模块 */}
        <div className="reward">
          <div className="reward-wrap">
            <div className="reward-rule" onClick={() => {
              this.setState({
                ruleState: true
              })
            }}>
              {lang.rewardtitle}
            </div>
            <div
              className="rr-temp"
              style={{ display: this.state.ruleState ? "block" : "none" }}
              onClick={() => {
                this.setState({
                  ruleState: false
                })
              }}>
              <div className="reward-rule-reminder">
                <div className="rr-title">
                  {lang.rewardtitle}
                </div>
                <div
                  className={`rr-content ${language == 'ar' ? 'arfz' : ''}`}
                  dangerouslySetInnerHTML={{ __html: lang.rewardRule || '' }}
                >
                </div>
              </div>
              <div className="reward-rule-reminder-bg">
              </div>
            </div>
            {/* top1 */}
            <div className="reward-rank-wrap">
              <div className="title">TOP1</div>
              <div className="rank-box">
                <div className="box">
                  <div>
                    <img src={rewardList && rewardList.top1 && rewardList.top1[0].image || '/img/activity/national/bor111.png'} alt="" />
                    <span>{rewardList && rewardList.top1 && rewardList.top1[0].name}</span>
                  </div>
                  <div>
                    <img src={rewardList && rewardList.top1 && rewardList.top1[1].image || '/img/activity/national/z01.png'} alt="" />
                    <span>
                      {rewardList && rewardList.top1 && rewardList.top1[1].name}
                    </span>
                  </div>
                  <div>
                    <img src={rewardList && rewardList.top1 && rewardList.top1[2].image || '/img/activity/national/sz111.png'} alt="" />
                    <span>{rewardList && rewardList.top1 && rewardList.top1[2].name}</span>
                  </div>
                </div>
              </div>
              <div className="rule-desc">{lang.medal}</div>
              <div className="rule-desc">{lang.allr}</div>
            </div>
            {/* top2  */}
            <div className="reward-rank-wrap">
              <div className="title">TOP2</div>
              <div className="rank-box">
                <div className="box">
                  <div>
                    <img src={rewardList && rewardList.top2 && rewardList.top2[0].image || '/img/activity/national/bor222.png'} alt="" />
                    <span>{rewardList && rewardList.top2 && rewardList.top2[0].name}</span>
                  </div>
                  <div>
                    <img src={rewardList && rewardList.top2 && rewardList.top2[1].image || '/img/activity/national/z02.png'} alt="" />
                    <span>
                      {rewardList && rewardList.top2 && rewardList.top2[1].name}
                    </span>
                  </div>
                  <div>
                    <img src={rewardList && rewardList.top2 && rewardList.top2[2].image || '/img/activity/national/sz222.png'} alt="" />
                    <span>{rewardList && rewardList.top2 && rewardList.top2[2].name}</span>
                  </div>
                </div>
              </div>
              <div className="rule-desc">{lang.medal}</div>
              <div className="rule-desc">{lang.allr}</div>
            </div>
            {/* top3  */}
            <div className="reward-rank-wrap">
              <div className="title">TOP3</div>
              <div className="rank-box">
                <div className="box">
                  <div>
                    <img src={rewardList && rewardList.top3 && rewardList.top3[0].image || '/img/activity/national/bor333.png'} alt="" />
                    <span>{rewardList && rewardList.top3 && rewardList.top3[0].name}</span>
                  </div>
                  <div>
                    <img src={rewardList && rewardList.top3 && rewardList.top3[1].image || '/img/activity/national/z03.png'} alt="" />
                    <span>
                      {rewardList && rewardList.top3 && rewardList.top3[1].name}
                    </span>
                  </div>
                  <div>
                    <img src={rewardList && rewardList.top3 && rewardList.top3[2].image || '/img/activity/national/sz333.png'} alt="" />
                    <span>{rewardList && rewardList.top3 && rewardList.top3[2].name}</span>
                  </div>
                </div>
              </div>
              <div className="rule-desc">{lang.medal}</div>
              <div className="rule-desc">{lang.allr}</div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national/Reward/index.js